import { FC, useState, useEffect, Fragment, ReactElement } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  StyleTabsBgWrapper,
  StyleTabsItems,
  StyleTabItem,
  StyleRow,
} from './style'
interface ItemProps {
  title: string
  key: string
  Component?: FC
  props?: any
}
interface TabsProps {
  items: ItemProps[]
  restore?: boolean
  styleWrapper?: string
  rightComponent?: ReactElement
}

const Tabs: FC<TabsProps> = ({
  items,
  restore = false,
  styleWrapper = '',
  rightComponent,
}) => {
  const [active, setActive] = useState<string>('')
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const selected = items?.find((item: any) => item?.key == active)
  const Component = selected?.Component
  const props = selected?.props
  const handleClickTab = async (event: any) => {
    const id = (event.target as HTMLElement)
      .closest('[data-id]')
      ?.getAttribute('data-id')
    const item = items[id]
    if (!!item) {
      setActive(item?.key)
      if (!!restore) {
        navigate(`${location?.pathname}?tab=${item?.key}`)
      }
    }
  }

  useEffect(() => {
    if (!!items?.length && items[0] && !tab) {
      setActive(items[0]?.key)
    } else {
      setActive(tab)
    }

    if (!restore) {
      window.scrollTo(0, 0)
    }
  }, [tab])

  return (
    <Fragment>
      <StyleRow>
        <StyleTabsBgWrapper>
          <StyleTabsItems onClick={handleClickTab} styleWrapper={styleWrapper}>
            {items?.map((item: ItemProps, index) => {
              return (
                <Fragment key={item?.key}>
                  <StyleTabItem
                    isActive={active == item?.key}
                    data-id={index}
                    type="button"
                  >
                    {item?.title}
                  </StyleTabItem>
                </Fragment>
              )
            })}
          </StyleTabsItems>
        </StyleTabsBgWrapper>
        {!!rightComponent && rightComponent}
      </StyleRow>
      {!!Component && <Component {...props} />}
    </Fragment>
  )
}

export default Tabs
